import React, {Fragment} from "react";
import {Input} from "reactstrap";
import StepQuestion from "components/Step/StepQuestion";
import StepButton from "components/Step/StepButton";
import StepInputLabel from "components/Step/StepInputLabel";
import StepFeedback from "components/Step/StepFeedback";
import ValidationHelperV2 from "utils/ValidationHelperV2";
import ValidationMethod from "utils/ValidationMethods";

export default class TextCaptureStep extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.yupRules = {};
        let errors = ValidationMethod.validateInitial(this, this.props.config);

        this.state = {
            errors: errors
        };

        this.fireChangeEvent = this.fireChangeEvent.bind(this);
    }

    validateRule(yupRule, value) {
        let result = ValidationHelperV2.validateField(yupRule, value);
        if (result === "") {
            return undefined;
        }
        return result;
    }

    onChange(e) {
        this.fireChangeEvent(e.target.id, e.target.value);
    }

    fireChangeEvent(key, value) {
        ValidationMethod.validateOnChange(this, key, value);

        if (this.props.onKeyValueChange) {
            this.props.onKeyValueChange(key, value);
        }
    }

    isInvalid(key) {
        return this.state.errors[key] !== undefined && this.state.errors[key].length > 0
    }

    render() {
        let value = this.props.value;
        let config = this.props.config || [];
        return <Fragment>
            {
                this.props.questionText && <StepQuestion>
                    {this.props.questionText}
                </StepQuestion>
            }
            {
                config.map((singleConfig, index) => {
                    return <Fragment key={index}>
                        {
                            singleConfig.questionText &&
                            <StepInputLabel>{singleConfig.questionText}</StepInputLabel>
                        }
                        <Input
                            id={singleConfig.field}
                            className={singleConfig.className}
                            type={"text"}
                            placeholder={singleConfig.placeholder}
                            value={singleConfig.value}
                            onChange={this.onChange.bind(this)}
                            invalid={this.isInvalid(singleConfig.field)}
                        />
                        <StepFeedback
                            className={singleConfig.className}
                        >
                            {this.state.errors[singleConfig.field]}
                        </StepFeedback>
                    </Fragment>
                })
            }
            <StepButton
                onClick={(e) => {
                    if (this.props.onNextClick)
                        this.props.onNextClick(value)
                }}
                disabled={Object.keys(this.state.errors).length > 0}
            >
                {this.props.nextText || "Next"}
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {this.props.backText || "Back"}
            </StepButton>
        </Fragment>
    }
}